import {useState} from "react"
import {apiSavedRoomsSave, apiSavedRoomsLoad} from "./Api"

const SATE_SAVE_KEY = "saved-solution"

export const dispatchSolutionLoadedEvent = () => {
    document.dispatchEvent(new Event('solutionLoaded'))
}

export const useSolutionRepository = () => {
    const [state, setState] = useState(() => loadState())

    const save = async (activePlanningId, planningIds, name) => {
        const responseData = await apiSavedRoomsSave(activePlanningId, planningIds, name)
        add(responseData)
    }

    const getSolutions = () => {
        return state
    }

    const count = () => {
        return getSolutions().length
    }

    const load = (roomCode) => {
        return apiSavedRoomsLoad(roomCode)
    }

    const setName = (panningCode, planningName) => {
        const newState = state.map(savedRoom => {
            if (savedRoom.code === panningCode) {
                return {...savedRoom, name: planningName}
            }
            return savedRoom
        })

        setState(newState)
        saveState(newState)
    }

    const remove = (solutionCode) => {
        setState(prevState => {
            saveState(prevState.filter(solution => solution.code !== solutionCode))
            return prevState.filter(solution => solution.code !== solutionCode)
        })
    }

    const add = (responseData, saveName = "") => {
        if(state.filter(item => item.code === responseData.code).length > 0) {
            return
        }

        const savedRoom = {
            code: responseData.code,
            name: responseData.name || saveName,
            datetime: responseData.timestamp,
            planningCount: responseData.plannings.length,
        }

        setState([savedRoom, ...state])
        saveState([savedRoom, ...state])
    }

    return {
        getSolutions,
        count,
        save,
        load,
        remove,
        setName,
        add
    }
}

const loadState = () => {
    return localStorage.getItem(SATE_SAVE_KEY) ? JSON.parse(localStorage.getItem(SATE_SAVE_KEY)) : []
}
const saveState = (solutions) => {
    localStorage.setItem(SATE_SAVE_KEY, JSON.stringify(solutions))
}
